var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initState = {
    section: {},
    page: {},
};
export default function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case 'APP_SETTINGS/SET_SECTION_SETTINGS': {
            return __assign(__assign({}, state), { section: __assign(__assign({}, state.section), action.payload) });
        }
        case 'APP_SETTINGS/SET_PAGE_SETTINGS': {
            return __assign(__assign({}, state), { page: __assign(__assign({}, state.page), action.payload) });
        }
        case 'APP_SETTINGS/SET_GLOBAL_SETTINGS': {
            return __assign(__assign({}, state), action.payload);
        }
        case 'APP_SETTINGS/RESET_GLOBAL_SETTINGS': {
            return initState;
        }
        default: {
            return state;
        }
    }
}
